import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './parallax.scss.js';

class Parallax extends s {
    setupParallax() {
        var _a;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const content = document.querySelector('.content');
        const parallaxElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.parallax');
        let windowHeight = window.innerHeight;
        let contentHeight = (content === null || content === void 0 ? void 0 : content.offsetHeight) || 0;
        if (!content)
            return;
        const blockHeight = Math.round(contentHeight);
        this.style.setProperty('--parallax-height', `${blockHeight}px`);
        this.style.position = 'absolute';
        this.style.top = '0';
        this.style.bottom = 'auto';
        if (parallaxElement) {
            parallaxElement.style.backgroundSize = `100% auto`;
        }
        if (prefersReducedMotion) {
            this.style.opacity = '1';
            return;
        }
        const updateDimensions = () => {
            windowHeight = window.innerHeight;
            contentHeight = content.offsetHeight;
        };
        const handleScroll = () => {
            const scrollPercentage = Math.min(window.scrollY / windowHeight, 1);
            this.style.opacity = scrollPercentage.toString();
            if (parallaxElement) {
                const yPos = window.scrollY * -0.5;
                parallaxElement.style.setProperty('--parallax-y', `${yPos}px`);
            }
        };
        let ticking = false;
        document.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });
        window.addEventListener('resize', () => {
            updateDimensions();
            const newBlockHeight = Math.round(contentHeight);
            this.style.setProperty('--parallax-height', `${newBlockHeight}px`);
            handleScroll();
        });
        handleScroll();
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'presentation');
        this.setAttribute('aria-hidden', 'true');
        setTimeout(() => this.setupParallax(), 0);
    }
    render() {
        return x `<div class="parallax" style='background-image:url("${this.background}")' role="presentation" aria-hidden="true"></div>`;
    }
}
Parallax.styles = css_248z;
__decorate([
    n({ type: String })
], Parallax.prototype, "background", void 0);
customElements.define('parallax-bg', Parallax);

export { Parallax };
